/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable import/extensions, import/no-unresolved */
import Qs from 'qs'
import { HttpStatusCode } from '../../protocols/http/http-client'
import { UnauthorizedError } from '../../../domain/errors/unauthorized-error'
import { AccessDeniedError } from '../../../domain/errors/access-denied-error'
import { UnexpectedError } from '../../../domain/errors/unexpected-error'
import { NotFoundError } from '../../../domain/errors/not-found-error'

export class RemoteQuotasManagers {
  url: string

  httpClient: any

  constructor(url: string, httpClient: any) {
    this.url = url
    this.httpClient = httpClient
  }

  async load(id: string, params?: any) {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{ID}', id),
      method: 'get',
      params,
    })

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new UnauthorizedError()
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.ok: return httpResponse.body
      default: throw new UnexpectedError()
    }
  }

  async index(params?: any) {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
      params,
      paramsSerializer(paramsAux: any) {
        return Qs.stringify(paramsAux, { arrayFormat: 'repeat' })
      },
    })

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new UnauthorizedError()
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.ok: return httpResponse.body
      default: throw new UnexpectedError()
    }
  }

  async update(data: any) {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'put',
      data,
    })

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new UnauthorizedError()
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.notFound: throw new NotFoundError()
      case HttpStatusCode.ok: return httpResponse.body
      default: throw new UnexpectedError()
    }
  }

  async updateManagers(data: any) {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'put',
      params: data,
      paramsSerializer(paramsAux: any) {
        return Qs.stringify(paramsAux, { arrayFormat: 'repeat' })
      },
    })

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new UnauthorizedError()
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.notFound: throw new NotFoundError()
      case HttpStatusCode.ok: return httpResponse.body
      default: throw new UnexpectedError()
    }
  }

  async updateLine(data: any) {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'put',
      data,
    })

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new UnauthorizedError()
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.notFound: throw new NotFoundError()
      case HttpStatusCode.ok: return httpResponse.body
      default: throw new UnexpectedError()
    }
  }

  async updatePopUp(id: string, data: any, params: any) {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{ID}', id),
      method: 'put',
      data,
      params,
    })

    const tempData = httpResponse.body.length > 0 ? httpResponse.body[0].msgUsuario : 'Erro na requisição'

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new UnauthorizedError()
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.notFound: throw new NotFoundError()
      case HttpStatusCode.ok: return httpResponse.body
      case HttpStatusCode.badRequest: return new Error(tempData)
      default: throw new UnexpectedError()
    }
  }

  async updateStatus(data: any) {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'put',
      data,
    })

    const tempData = httpResponse.body.length > 0 ? httpResponse.body[0].msgUsuario : 'Erro na requisição'

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new UnauthorizedError()
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.notFound: throw new NotFoundError()
      case HttpStatusCode.badRequest: throw new Error(tempData)
      case HttpStatusCode.ok: return httpResponse.body
      default: throw new UnexpectedError()
    }
  }

  async create(data: any) {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'post',
      data,
    })

    const tempData = httpResponse.body.length > 0 ? httpResponse.body[0].msgUsuario : ''

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new UnauthorizedError()
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.notFound: throw new NotFoundError()
      case HttpStatusCode.ok: return httpResponse.body
      case HttpStatusCode.badRequest: return new Error(tempData || 'Erro na requisição')
      case HttpStatusCode.serverError: return tempData ? new Error(tempData) : new UnexpectedError()
      default: throw new UnexpectedError()
    }
  }
}
